'use client';
import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import LeftArrow from '@repo/ui/src/components/Icons/LeftArrow';
import { useDrawer } from '@repo/ui/src/modules/UI/hooks/useDrawer';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  title?: string;
}

export const DrawerHeader = ({ title }: Props) => {
  const { close, closeAll, id, inDrawer, index } = useDrawer();

  const showCloseArrow = index > 0;

  return (
    <div
      className={classNames(
        'mx-auto max-w-3xl w-full grid mb-10 sm:mb-0 bg-warm-100 sm:bg-transparent shadow-drawerHeader sm:shadow-none',
        showCloseArrow ? 'grid-cols-[auto_1fr_auto]' : 'grid-cols-[1fr_auto]',
      )}
    >
      {inDrawer && showCloseArrow && (
        <button
          onClick={close}
          aria-label="Close"
          className="p-6 bg-warm-200 z-10 max-h-20 tra-btn-bare"
        >
          <LeftArrow />
        </button>
      )}
      <div className="p-6 sm:px-16 sm:pt-14 sm:pb-8">
        <h2 className="tra-text-web-heading-4 w-full mb-0" id={`${id}-drawer-title`}>
          {title}
        </h2>
      </div>
      {inDrawer && (
        <button
          onClick={closeAll}
          aria-label="Close"
          className="p-6 bg-warm-300 z-10 max-h-20 tra-btn-bare"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};
